/**
 * (owner, Sep 23: "we need selectable filters for the big phone map — now it is cluttered and slow; it would be nice to select what
 * to show on it") What the big map shows, per device: a Layers button on the map opens the list, a tap turns a layer on or off.
 * `streets` off keeps the map to the big roads at every zoom — the cheapest map there is.
 */
export type MapLayer = 'towns' | 'fuel' | 'services' | 'guns' | 'travel' | 'shops' | 'gangs' | 'garbage' | 'players' | 'mine' | 'streets';
export const MAP_LAYERS: { id: MapLayer; icon: string; label: string; on: boolean }[] = [
  { id: 'mine', icon: '🏠', label: 'My places & car', on: true },
  { id: 'players', icon: '👥', label: 'Players', on: true },
  { id: 'towns', icon: '🏙', label: 'Town names', on: true },
  { id: 'fuel', icon: '⛽', label: 'Fuel & charging', on: true },
  { id: 'services', icon: '🏥', label: 'Hospitals, police, banks', on: true },
  { id: 'guns', icon: '🔫', label: 'Guns & car dealers', on: true },
  { id: 'travel', icon: '✈', label: 'Airfields, stations, marinas', on: true },
  { id: 'gangs', icon: '◆', label: 'Gangs & turf', on: true },
  { id: 'shops', icon: '🛍', label: 'Shops, food & looks', on: false },
  { id: 'garbage', icon: '🗑', label: 'Bins & landfill (on in the truck)', on: false },
  { id: 'streets', icon: '🛣', label: 'Side streets', on: true },
];
const KEY = 'sprawl.mapLayers';
function load(): Record<MapLayer, boolean> {
  const out = Object.fromEntries(MAP_LAYERS.map((l) => [l.id, l.on])) as Record<MapLayer, boolean>;
  try { const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(KEY) : null; if (raw) { const saved = JSON.parse(raw) as Partial<Record<MapLayer, boolean>>; for (const l of MAP_LAYERS) if (typeof saved[l.id] === 'boolean') out[l.id] = saved[l.id]!; } } catch { /* the defaults */ }
  return out;
}
/** the layers on (true) and off, as this device left them */
export const mapLayers: Record<MapLayer, boolean> = load();
/** the Layers list open over the map */
export const layersPanel = { open: false };
function saveLayers(): void { try { localStorage.setItem(KEY, JSON.stringify(mapLayers)); } catch { /* per session then */ } }
export function toggleMapLayer(id: MapLayer): void { mapLayers[id] = !mapLayers[id]; saveLayers(); }
/** (owner, Sep 24: "add map filter select all/none") every layer on, or every one off */
export function setAllMapLayers(on: boolean): void { for (const l of MAP_LAYERS) mapLayers[l.id] = on; saveLayers(); }
/** a tap on the map's Layers button, one of its rows or its All / None (hit ids `map:layers`, `map:layer:<id>`, `map:layers:all|none`); false when the id is not the map's */
export function mapLayerAct(id: string): boolean {
  if (id === 'map:layers') { layersPanel.open = !layersPanel.open; return true; }
  if (id === 'map:layers:all' || id === 'map:layers:none') { setAllMapLayers(id === 'map:layers:all'); return true; }
  if (id.startsWith('map:layer:')) { const l = id.slice(10) as MapLayer; if (MAP_LAYERS.some((x) => x.id === l)) toggleMapLayer(l); return true; }
  return false;
}
